
var Events = {
	registered : {},
	scrollEvent : {
		register: function(evtName, callback) {
			Events.registered[evtName] = callback;
		},
		remove: function(evtName) {
			Events.registered[evtName] = null;
		}
	}
};

module.exports = Events;


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-scroll/lib/mixins/scroll-events.js
 ** module id = 183
 ** module chunks = 1
 **/